import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";

const LazyToasters = () => (
  <>
    <Toaster />
    <Sonner />
  </>
);

export default LazyToasters;
